export default __webpack_public_path__ + "static/media/advisor-mm.23eb7a09.jpg";